import { setRange } from './helpers';

export const setCeilingHeight = setRange('ceiling_height');
